import React from 'react';
import { Pane, Text } from 'evergreen-ui';
import { Anchor } from '../_ui/A';
import { Environment } from 'services/Environment';

export const PoweredBy = ({ url = `${Environment.MARKETPLACE_URL}` }) => {
    return (
        <Pane display="flex" justifyContent="center" marginTop={20} marginBottom={20}>
            <Anchor href={url}>
                <Pane display="flex" alignItems="center">
                    <Text whiteSpace="nowrap">Powered by</Text>
                    <img
                        src={`${Environment.ASSETS_URL}/logos/logo.svg`}
                        alt="Cademy logo"
                        style={{ marginLeft: '5px', height: '14px', display: 'block' }}
                    />
                </Pane>
            </Anchor>
        </Pane>
    );
};
